<template>
  <div class="section_wrap">
    <div class="head">
      <!-- <div class="head-left"></div> -->
      <div class="head-center">
        <div class="title">
          <div class="title-text">直播信息</div>
          <div class="title-icon" @click="toMoreData()">
            <el-image class="elimage" :src="moreicon" />
          </div>
        </div>
      </div>
      <div class="head-right">
        <div class="more">
          <el-button type="primary" plain round icon="el-icon-date" @click="showDate()">查看日历</el-button>
        </div>
      </div>
    </div>
    <div class="timeLineCont">
      <el-divider class="lineCont"></el-divider>
      <div class="playCont" v-for="(v, i) in videoList" :key="i">
        <div class="svgBg">
          <img :src="!i ? playCurImg : playImg" />
        </div>
        <div class="timeText" :class="!i ? 'active' : ''">
          {{ v.date }}
          <span v-if="!i">今日</span>
        </div>
        <template v-if="v.list.length">
          <div class="goods-list">
            <div class="goods-item" v-for="(item, index) in v.list" :key="index">
              <div class="goods-item-img">
                <template>
                  <div class="goods-img" @click="toDetail(item)">
                    <el-image class="image" :src="item.cover" @error="handleError" />
                  </div>
                </template>
              </div>
              <div class="goods-item-info">
                <div class="title ellipsis">{{ item.title }}</div>
                <div class="content">
                  <div class="time ellipsis">
                    <span class="tit">活动时间：</span>
                    <span class="txt">{{ item.start_time | dataformat }}</span>
                  </div>
                  <div class="tags ellipsis">
                    <el-tag class="tag" size="small" :type="item.status === 1 ? '' : 'danger'">
                      <img class="icon" :src="item.status === 1 ? liveStateImg02 : liveStateImg01" />
                      {{ item.status | stateFilter }}
                    </el-tag>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <el-empty :image-size="60"></el-empty>
        </template>
      </div>
    </div>
    <Customdialog ref="live_calendar" :showclose="true" title="直播日历" width="75%" type="table" class="dateDialog"
      :footer="false">
      <div slot="dialogbody" class="dialogbody">
        <LiveCalendar v-if="initCalendar"></LiveCalendar>
      </div>
    </Customdialog>
  </div>
</template>

<script>
/* 引入组件 */
import Customdialog from "@/components/customdialog.vue"
import LiveCalendar from "@/views/live/components/live-calendar.vue"
/* 引用方法 */
import dayjs from "dayjs"
/* Api接口 */
import { getRecentLiveList } from "@/api/live.js"

const stateMap = {
  0: "未开始",
  1: "直播中",
  3: "直播已结束"
}

export default {
  name: "homeLive",
  components: {
    Customdialog,
    LiveCalendar
  },
  data() {
    return {
      playImg: require("@/assets/home/play.png"),
      playCurImg: require("@/assets/home/play_1.png"),
      loading: false,
      videoList: [],
      moreicon: require("@/assets/home/more.png"),
      goodsimage: require("@/assets/default/image02.jpg"),
      liveStateImg01: require("@/assets/home/locking.png"),
      liveStateImg02: require("@/assets/home/live_streaming.png"),
      initCalendar: false
    }
  },
  filters: {
    dataformat(value) {
      if (!value) return ""
      return dayjs.unix(value).format("YYYY-MM-DD HH:mm:ss")
    },
    stateFilter(status) {
      return stateMap[status]
    },
  },
  computed: {},
  created() {
    this.getInitRecentList()
  },
  methods: {
    handleError(e) {
      // 当图片加载失败时，将图片地址设置为默认图片
      e.target.src = this.goodsimage
      // 可以添加额外的处理，比如提示用户或者进行日志记录
    },
    getNextDate(day = 1, format = "{y}-{m}-{d}") { //当前日期后4天
      const nDate = new Date()
      nDate.setDate(nDate.getDate() + day)
      const formatObj = {
        y: nDate.getFullYear(),
        m: nDate.getMonth() + 1,
        d: nDate.getDate(),
      }
      return format.replace(/{([ymd])+}/g, (result, key) => {
        const value = formatObj[key]
        return value.toString().padStart(2, "0")
      })
    },
    getInitRecentList() {
      //初始化近5天的直播记录
      let currentTime = parseInt(new Date().getTime() / 1000)
      let start_time = parseInt(this.timeFormat(0).replaceAll('.', ''))
      let end_time = parseInt(this.getNextDate(4, "{y}{m}{d}"))
      let params = {
        start_date: start_time,
        end_date: end_time
      }
      getRecentLiveList(params).then(res => {
        if (res.code === 0) {
          res.data.forEach(item => {
            if (item?.list && item?.list.length) {
              item.list.forEach(ele => {
                if (ele.start_time > currentTime) { // 未开始
                  ele.status = 0
                } else {
                  ele.status = 1
                }
              })
            }
            this.videoList.push({
              date: item.date,
              list: item.list || []
            })
          })
        }
      })
    },
    timeFormat(data) { //补齐时间，返回格式为:yyyy.mm.dd
      let dateTime = new Date()
      if (!data) {
        dateTime = new Date()
      } else {
        dateTime = this.dateValue
      }
      let strArr = this.formatDate(dateTime)
      let timer = ''
      strArr.forEach((item, index) => {
        if (!index) {
          timer = item
        } else {
          if (parseInt(item) < 10) {
            item = '.0' + item
          } else {
            item = '.' + item
          }
          timer = timer + item
        }
      })
      return timer
    },
    formatDate(date) {
      let y = date.getFullYear()
      let m = date.getMonth() + 1
      let d = date.getDate()
      return [y, m, d]
    },
    // 加载更多数据
    toMoreData() {
      window.localStorage.setItem("menuId", 4)
      this.$store.dispatch("setmenuid", 4)
      this.$router.push({
        path: "/home/live",
      })
    },
    toDetail(item) {
      window.localStorage.setItem("menuId", 4)
      this.$store.dispatch("setmenuid", 4)
      this.$router.push({
        path: "/move",
        query: {
          sn: item.sn,
        },
      })
    },
    showDate() {
      this.initCalendar = false
      this.$nextTick(() => {
        this.initCalendar = true
        this.$refs["live_calendar"].dialogopenbt()
      })
    },
  },
};
</script>
<style scoped lang="scss">
.section_wrap {
  width: 100%;

  .head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 40px;
    margin-bottom: 20px;

    .head-left {
      width: 64px;
    }

    .head-center {

      // flex: 1;
      .title {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0 10px;

        .title-icon {
          width: 32px;
          min-width: 32px;
          height: 32px;
          margin-left: 10px;

          .elimage {
            width: 100%;
            height: 100%;
          }
        }

        .title-text {
          color: #000;
          font-size: 30px;
          font-weight: bold;
          line-height: 40px;
        }
      }
    }

    .head-right {
      .more {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        height: 40px;
        margin-left: 15px;

        .elimage {
          width: 38px;
          height: 38px;
        }
      }
    }
  }
}

.timeLineCont {
  position: relative;
  display: flex;
  min-height: 300px;

  .lineCont {
    position: absolute;
    top: 5px;
    height: 2px;
    background: #ebeef5;
  }

  .playCont {
    width: calc((100% - 75px) / 5);
    margin-left: 15px;

    .svgBg {
      width: 54px;
      height: 54px;
      border-radius: 50%;
      background-color: rgba(248, 248, 251, 1);
      display: flex;
      justify-content: center;
      align-items: center;
      margin-left: 50%;
      transform: translateX(-27px);
    }

    .timeText {
      text-align: center;
      font-size: 14px;
      font-weight: 500;
      line-height: 40px;
      color: #666666;
    }

    .timeText.active {
      font-size: 16px;
      color: #005292;
    }

    .goods-list {
      display: flex;
      flex-direction: column;

      .goods-item {
        width: 100%;
        height: 360px;
        background-color: #fff;
        border-radius: 5px;
        overflow: hidden;
        cursor: pointer;

        .goods-item-img {
          position: relative;
          height: calc(100% - 124px);

          .goods-img {
            width: 100%;
            height: 100%;
            background: aliceblue;

            .image {
              display: inline-block;
              -webkit-transition-duration: 0.3s;
              transition-duration: 0.3s;
              -webkit-transition-property: transform;
              transition-property: transform;
              -webkit-transform: translateZ(0);
              transform: translateZ(0);
              box-shadow: 0 0 1px rgba(0, 0, 0, 0);
            }

            .image:hover,
            .image:focus,
            .image:active {
              -webkit-transform: scale(1.1);
              transform: scale(1.1);
            }

            .image {
              width: 100%;
              height: 100%;
            }
          }

          .default-img {
            width: 100%;
            height: 235px;
            // background: #daebfc;
            text-align: center;
            background: aliceblue;

            .image {
              display: inline-block;
              -webkit-transition-duration: 0.3s;
              transition-duration: 0.3s;
              -webkit-transition-property: transform;
              transition-property: transform;
              -webkit-transform: translateZ(0);
              transform: translateZ(0);
              box-shadow: 0 0 1px rgba(0, 0, 0, 0);
            }

            .image:hover,
            .image:focus,
            .image:active {
              -webkit-transform: scale(1.1);
              transform: scale(1.1);
            }

            .image {
              width: 100%;
              height: 100%;
            }
          }
        }

        .goods-item-info {
          height: 124px;
          padding: 10px 15px;
          background: #ffffff;
          box-sizing: border-box;

          .title {
            color: #000;
            font-size: 16px;
            font-weight: 500;
            line-height: 40px;
          }

          .content {

            .tit,
            .txt {
              color: #999;
              font-size: 12px;
              font-weight: 400;
              height: 20px;
              line-height: 20px;
              padding: 2px 5px;
              border-radius: 12px;
              margin-bottom: 10px;
            }

            .time {
              margin-bottom: 10px;
            }

            .tags {
              .tag {
                border-radius: 20px;

                .icon {
                  width: 16px;
                  height: 16px;
                  vertical-align: text-bottom;
                }
              }
            }
          }
        }
      }

      .goods-item:not(:first-child) {
        margin-top: 15px;
      }
    }
  }
}

@media screen and (max-width: 640px) {
  .section_wrap {
    .head {
      flex-wrap: wrap;
      height: auto;
      margin-bottom: 10px;

      .head-center {
        .title {
          .title-icon {
            width: 18px;
            height: 18px;
          }

          .title-text {
            font-size: 18px;
          }
        }
      }

      .head-right {
        .more {
          margin-left: 5px;

          .el-button {
            font-size: 12px;
            padding: 8px 12px;
          }
        }
      }
    }

    .timeLineCont {
      flex-direction: column;
      min-height: auto;

      .lineCont {
        display: none;
      }

      .playCont {
        width: 100%;
        margin-left: 0;
        margin-bottom: 20px;

        .svgBg {
          margin-left: 0;
          transform: none;
          width: 36px;
          height: 36px;

          img {
            width: 24px;
            height: 24px;
          }
        }

        .timeText {
          text-align: left;
          font-size: 13px;
          line-height: 30px;
        }

        .timeText.active {
          font-size: 14px;
        }

        .goods-list {
          .goods-item {
            height: auto;
            display: flex;
            flex-direction: row;

            .goods-item-img {
              width: 120px;
              min-width: 120px;
              height: auto;

              .goods-img {
                height: 100px;

                .image {
                  display: block;
                  object-fit: cover;
                }
              }

              .default-img {
                height: 100px;

                .image {
                  display: block;
                  object-fit: cover;
                }
              }
            }

            .goods-item-info {
              height: auto;
              flex: 1;
              padding: 8px 10px;

              .title {
                font-size: 14px;
                line-height: 24px;
              }

              .content {
                .time {
                  margin-bottom: 5px;
                }

                .tit,
                .txt {
                  font-size: 11px;
                }
              }
            }
          }

          .goods-item:not(:first-child) {
            margin-top: 10px;
          }
        }
      }
    }

    .dateDialog {
      ::v-deep .el-dialog {
        width: 95% !important;
        margin-top: 10vh !important;

        .el-dialog__header {
          padding: 12px 15px;

          .el-dialog__title {
            font-size: 15px;
          }
        }

        .el-dialog__body {
          padding: 10px;
        }
      }
    }
  }
}

@media screen and (min-width: 640px) and (max-width: 1200px) {
  .section_wrap {
    .head {
      .head-center {
        .title {
          .title-icon {
            width: 24px;
            height: 24px;
          }

          .title-text {
            font-size: 24px;
          }
        }
      }

      .head-right {
        .more {
          margin-left: 10px;

          .el-button {
            font-size: 13px;
          }
        }
      }
    }

    .timeLineCont {
      .playCont {
        width: calc((100% - 45px) / 3);

        .svgBg {
          width: 40px;
          height: 40px;
          transform: translateX(-20px);

          img {
            width: 28px;
            height: 28px;
          }
        }

        .goods-list {
          .goods-item {
            height: 320px;

            .goods-item-img {
              height: calc(100% - 110px);
            }

            .goods-item-info {
              height: 110px;

              .title {
                font-size: 14px;
                line-height: 30px;
              }

              .content {

                .tit,
                .txt {
                  font-size: 11px;
                }
              }
            }
          }
        }
      }
    }
  }
}

@media screen and (min-width: 1200px) {
  .section_wrap {
    .head {
      .head-center {
        .title {
          .title-icon {
            width: 32px;
            height: 32px;
          }

          .title-text {
            font-size: 30px;
          }
        }
      }

      .head-right {
        .more {
          .elimage {
            width: 38px;
            height: 38px;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 640px) {
  .section_wrap {
    .head {
      flex-wrap: wrap;

      .head-center {
        .title {
          .title-text {
            font-size: 20px;
          }

          .title-icon {
            width: 24px;
            min-width: 24px;
            height: 24px;
          }
        }
      }

      .head-right {
        width: 100%;
        margin-top: 10px;
      }
    }

    .timeLineCont {
      .playCont {
        .goods-list {
          .goods-item {
            flex-direction: column;
            height: auto;

            .goods-item-img {
              width: 100%;
              height: 140px;
            }

            .goods-item-info {
              width: 100%;
              padding: 10px;

              .title {
                font-size: 14px;
              }
            }
          }
        }
      }
    }
  }
}

@media screen and (min-width: 640px) and (max-width: 1200px) {
  .section_wrap {
    .timeLineCont {
      .playCont {
        .goods-list {
          .goods-item {
            .goods-item-img {
              width: 200px;
              min-width: 200px;
            }

            .goods-item-info {
              width: calc(100% - 200px);
            }
          }
        }
      }
    }
  }
}
</style>